<template>
  <div
    v-if="login"
    class="login-helper center"
  >
    <router-link to="/signup">註冊會員</router-link>
    <a
      href="javascript:void(0);"
      @click="triggerModal"
      v-text="'忘記密碼'"
    /> 
    </div>
    <div v-else>
      <div        
        class="login-helper"
        style="float:left;"
      >
        <Icon
          size="20"
          type="android-person"
          color="#e0e0e0"
        />
        <router-link
          v-for="item in headerList"
          :key="`${item.to}-helper`"
          :to="item.to"
          v-text="item.text"
        />
      </div>
      
      <div style="float:left;">
      <router-link 
            :to="{path:'/help'}"      
          >
          <img 
          style="max-width:20px;min-width:15px;margin-left:10px;" 
          width="100%" 
          src="@/assets/information.png">
          </router-link>
      </div>
    
</template>

<script>
  import { Icon } from 'iview';

  export default {
    components: { Icon },
    props: {
      headerList: {
        type: Array,
        default: () => [
          { to: '/login', text: '登入' },
          { to: '/signup', text: '註冊' }
        ]
      },
      login: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      triggerModal() {
        this.$emit('input', true);
      }
    }
  };
</script>

